import { useEffect } from 'react'

import useApiGet from 'Pods/Shared/Hooks/useApiGet'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import { VARIATION_TYPES } from 'Pods/ThreeDStudio/constants'
import { restoreActiveConversion } from 'Pods/ThreeDStudio/Store/actions/export'
import {
  setRunId,
  setSessionId,
  setIsGenerating,
  setIsEnhancing,
  setEnhancingSessionId,
  setTriggeredBy,
} from 'Pods/ThreeDStudio/Store/actions/generation'
import { GENERATION_TRIGGER_KEY } from 'Pods/ThreeDStudio/Store/constants'

export default function usePendingGeneratorRun() {
  const { getData } = useApiGet()
  const { isCurrentUser: isLoggedIn } = usePageConfig() || {}

  useEffect(() => {
    if (isLoggedIn !== true) {
      return
    }

    getData({
      path: '/api/internal/generator/runs/pending',
      onSuccess: (response) => {
        const data = response.data?.data
        const first = data?.[0]
        const {
          id: runId,
          created_at: createdAt,
          providerModelId,
          createdNewSession,
        } = first?.runs?.[0] || {}

        if (runId != null) {
          setRunId(runId)
          setIsGenerating(true, createdAt)
          setSessionId(first.session)

          // A run that did not create a new session and whose provider model is an
          // enhancement is an in-flight enhancement: restore the "Processing..." card
          // for its session and resume the in-progress label on the originating tab's
          // button. An initial generation (new session) pins it to the main generate
          // button instead.
          const variationType = VARIATION_TYPES[providerModelId]
          const isEnhancement = createdNewSession === false && !!variationType?.isEnhancement
          setIsEnhancing(isEnhancement)
          if (isEnhancement) {
            setEnhancingSessionId(first.session)
            setTriggeredBy(variationType.tab ?? null)
          } else {
            setTriggeredBy(GENERATION_TRIGGER_KEY)
          }
        }

        const activeConversion = response.data?.active_conversion
        if (activeConversion) {
          restoreActiveConversion(activeConversion)
        }
      },
    })
  }, [getData, isLoggedIn])
}
